import { render, staticRenderFns } from "./ui-number.vue?vue&type=template&id=3429639e&scoped=true"
import script from "./ui-number.vue?vue&type=script&lang=js"
export * from "./ui-number.vue?vue&type=script&lang=js"
import style0 from "./ui-number.vue?vue&type=style&index=0&id=3429639e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3429639e",
  null
  
)

export default component.exports